/* vs-pdp.js — Vachansutra product page behaviour.
   All configuration comes from the <script type="application/json" data-vs-config>
   block the section renders, so this file contains no Liquid and can be edited
   on its own. Runs once per section instance. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.vsReady === '1') return;
    root.dataset.vsReady = '1';

    var cfgEl = root.querySelector('[data-vs-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { cfg = {}; }

    var UNIT  = Number(cfg.unit) || 0;
    var BOGO  = !!cfg.bogo;
    var BUY_N = Number(cfg.buyN) || 1;
    var GET_N = Number(cfg.getN) || 1;
    var MONEY = cfg.money || '{{amount}}';

    function fmt(cents) {
      var n = cents / 100;
      var s = n.toLocaleString('en-IN', {
        minimumFractionDigits: n % 1 ? 2 : 0,
        maximumFractionDigits: 2
      });
      return String(MONEY).replace(/\{\{\s*amount[^}]*\}\}/, s);
    }

    /* ---------------- carousel ---------------- */
    var car = root.querySelector('[data-car]');
    if (car) {
      var track    = car.querySelector('[data-track]');
      var slides   = track ? track.querySelectorAll('.vs-slide') : [];
      var dotsWrap = car.querySelector('[data-dots]');
      var thumbs   = [].slice.call(car.querySelectorAll('[data-thumbs] .vs-thumb'));
      var prev     = car.querySelector('[data-prev]');
      var next     = car.querySelector('[data-next]');
      var idx = 0;
      var dots = [];

      if (dotsWrap && slides.length > 1) {
        for (var i = 0; i < slides.length; i++) {
          (function (i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'vs-dot';
            d.setAttribute('aria-label', 'Go to image ' + (i + 1));
            d.setAttribute('aria-current', i === 0 ? 'true' : 'false');
            d.addEventListener('click', function () { go(i); });
            dotsWrap.appendChild(d);
            dots.push(d);
          })(i);
        }
      }

      function paint() {
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        thumbs.forEach(function (t, i) {
          if (i === idx) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
        if (prev) prev.disabled = (idx === 0);
        if (next) next.disabled = (idx === slides.length - 1);
      }

      function go(i) {
        if (!track) return;
        idx = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        paint();
      }

      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.dataset.i, 10) || 0); });
      });

      var st;
      if (track) {
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () {
            var n = Math.round(track.scrollLeft / track.clientWidth);
            if (n !== idx) { idx = n; paint(); }
          }, 90);
        });
        window.addEventListener('resize', function () {
          clearTimeout(st);
          st = setTimeout(function () { track.scrollLeft = idx * track.clientWidth; }, 150);
        });
      }
      paint();
    }

    /* ---------------- quantity ---------------- */
    var qtyInput = root.querySelector('[data-qty]');
    var qtyDisp  = root.querySelector('[data-qty-display]');
    var minus    = root.querySelector('[data-minus]');
    var plus     = root.querySelector('[data-plus]');
    var hint     = root.querySelector('[data-hint]');
    var atc      = root.querySelector('[data-atc]');
    var sPrice   = root.querySelector('[data-sticky-price]');
    var sQty     = root.querySelector('[data-sticky-qty]');
    var qty      = parseInt(qtyDisp ? qtyDisp.textContent : '1', 10) || 1;

    function bogoPaid(q) {
      if (!BOGO) return q * UNIT;
      var group = BUY_N + GET_N;
      var full  = Math.floor(q / group) * BUY_N;
      var rest  = Math.min(q % group, BUY_N);
      return (full + rest) * UNIT;
    }

    function render() {
      if (!qtyDisp) return;
      var paid  = bogoPaid(qty);
      var saved = (qty * UNIT) - paid;

      qtyDisp.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      if (minus) minus.disabled = (qty <= 1);

      if (atc && !atc.disabled) {
        atc.innerHTML = (qty === 1)
          ? 'Add to bag'
          : 'Add ' + qty + ' to bag — ' + fmt(paid) +
            (saved > 0 ? ' <small>save ' + fmt(saved) + '</small>' : '');
      }
      if (sPrice) sPrice.textContent = fmt(paid);
      if (sQty)   sQty.textContent = (qty > 1) ? ('for ' + qty) : '';

      if (hint) {
        var group = BUY_N + GET_N;
        var inCycle = qty % group;
        var text = (!BOGO) ? '' : ((inCycle >= BUY_N || inCycle === 0) ? (cfg.hintDone || '') : (cfg.hintMore || ''));
        hint.innerHTML = text;
      }
    }

    if (minus) minus.addEventListener('click', function () { if (qty > 1)  { qty--; render(); } });
    if (plus)  plus.addEventListener('click',  function () { if (qty < 20) { qty++; render(); } });
    render();

    /* ---------------- gift note ---------------- */
    var gift  = root.querySelector('[data-gift]');
    var gnote = root.querySelector('[data-gift-note]');
    if (gift && gnote) {
      gift.addEventListener('change', function () {
        gnote.style.display = gift.checked ? 'block' : 'none';
      });
    }

    /* ---------------- dispatch cutoff ---------------- */
    var cut = root.querySelector('[data-cutoff]');
    if (cut) {
      var HOUR = Number(cfg.cutoffHour);
      if (isNaN(HOUR)) HOUR = 18;
      (function tick() {
        var now = new Date();
        var end = new Date(now);
        end.setHours(HOUR, 0, 0, 0);
        if (now >= end) {
          cut.innerHTML = cfg.cutoffPast || '';
        } else {
          var d = end - now;
          var h = Math.floor(d / 3.6e6);
          var m = Math.floor((d % 3.6e6) / 6e4);
          var s = Math.floor((d % 6e4) / 1000);
          cut.innerHTML = (cfg.cutoffLabel || '') + ' <b>' + h + 'h ' +
            String(m).padStart(2, '0') + 'm ' + String(s).padStart(2, '0') + 's</b> ' +
            (cfg.cutoffSuffix || '');
        }
        setTimeout(tick, 1000);
      })();
    }

    /* ---------------- pincode check ---------------- */
    var pin    = root.querySelector('[data-pin]');
    var pinGo  = root.querySelector('[data-pin-go]');
    var pinOut = root.querySelector('[data-pin-out]');
    if (pin && pinGo && pinOut) {
      var TICK  = cfg.tick || '';
      var METRO = String(cfg.metro || '').split(',').map(function (x) { return x.trim(); });
      var FAST  = Number(cfg.daysMetro) || 3;
      var SLOW  = Number(cfg.daysRest) || 6;

      function line(html) {
        return '<div class="vs-pin-line"><span class="vs-tick">' + TICK + '</span><span>' + html + '</span></div>';
      }
      function check() {
        var val = (pin.value || '').replace(/\D/g, '');
        pinOut.className = 'vs-pin-out on';
        if (val.length !== 6) {
          pinOut.innerHTML = '<div class="vs-pin-line" style="color:var(--vs-maroon)">Enter a valid 6-digit pincode.</div>';
          return;
        }
        var days = METRO.indexOf(val.slice(0, 3)) > -1 ? FAST : SLOW;
        var eta = new Date();
        eta.setDate(eta.getDate() + days);
        var when = eta.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
        pinOut.innerHTML =
          line('Delivery by <b>' + when + '</b> — ' + (cfg.dispatchText || '')) +
          (cfg.cod ? line('<b>Cash on Delivery</b> available at ' + val) : '') +
          line(cfg.shippingText || '') +
          line(cfg.exchangeText || '');
        try { localStorage.setItem('vs_pin', val); } catch (e) {}
      }
      pinGo.addEventListener('click', check);
      pin.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); check(); }
      });
      try {
        var saved = localStorage.getItem('vs_pin');
        if (saved) { pin.value = saved; check(); }
      } catch (e) {}
    }

    /* ---------------- variant switching ---------------- */
    var variants = Array.isArray(cfg.variants) ? cfg.variants : [];
    var opts = [].slice.call(root.querySelectorAll('[data-opt]'));
    if (opts.length && variants.length) {
      var idField = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-price]');
      opts.forEach(function (o) {
        o.addEventListener('change', function () {
          var chosen = [];
          [].slice.call(root.querySelectorAll('[data-opt]:checked')).forEach(function (c) { chosen.push(c.value); });
          var match = variants.filter(function (vr) {
            return vr.options.every(function (val, i) { return val === chosen[i]; });
          })[0];
          if (!match) return;
          if (idField) idField.value = match.id;
          UNIT = match.price;
          if (priceEl) priceEl.textContent = fmt(match.price);
          if (atc) {
            atc.disabled = !match.available;
            if (!match.available) atc.textContent = 'Sold out';
          }
          render();
        });
      });
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-vs-config]')).forEach(function (el) {
      init(el.closest('.vs'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.vs');
    if (el) { el.dataset.vsReady = ''; init(el); }
  });
})();
